import React, { type ReactNode } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import Link from "next/link";
import { Chip } from "ui/chips";
import { DirectionalButton } from "ui/button";

type PlatformCardProps = {
  eyebrow: string;
  title: string;
  description: string;
  href: string;
  ctaText: string;
  media: ReactNode;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
};

export function PlatformCard({
  eyebrow,
  title,
  description,
  href,
  ctaText,
  media,
  onMouseEnter,
  onMouseLeave,
}: PlatformCardProps) {
  return (
    <Flex
      as={Link}
      href={href}
      layerStyle="card.fill.light"
      gap="smallest"
      pb="tinier"
      overflow="hidden"
      width="100%"
      maxW={{ base: "cardMaxW", md: "100%" }}
      transition="all 0.15s ease-in-out"
      _hover={{
        bg: "rgba(243, 247, 245, 0.6)", // XX new.gray.50 with opacity adjustment
      }}
      _focus={{ outline: "none !important" }}
      _focusVisible={{
        outline: "none !important",
        boxShadow: "outline",
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Box
        w="440px"
        h="360px"
        maxW="90%"
        mx="auto"
        pos="relative"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        {media}
      </Box>

      <Flex align="start" justify="center" layerStyle="card.textWrapper.fill" flex={1} maxW="540px">
        <Chip>{eyebrow}</Chip>
        <Text as="h3" textStyle={{ base: "headline2", lg: "headline1", xl: "display3" }}>
          {title}
        </Text>
        {description && (
          <Text color="brand.textSecondary.light" textStyle="caption1">
            {description}
          </Text>
        )}
        <DirectionalButton as="div" size="sm" variant="tertiary" pl={0} mt="auto" pointerEvents="none">
          {ctaText}
        </DirectionalButton>
      </Flex>
    </Flex>
  );
}
